import React from "react";
import { Typography, Breadcrumbs, Link } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { IField, INavigation } from "../../app/types";

/* Functional component properties */
interface Props {
  classes: any;
  state: any;
  handler: (button: IField, caption: string) => void;
}

/* React Functional component */
export const BreadCrumb: React.FC<Props> = ({
  /* Function arguments (Props) */
  classes,
  state,
  handler,
}): JSX.Element => {
  function handleClick(event: React.MouseEvent<HTMLElement>) {
    event.preventDefault(); //TODO
    handler(
      {
        name: "BACK",
        text: "Back",
      } as IField,
      (event.target as HTMLElement).id
    );
  }

  return (
    <Breadcrumbs
      aria-label="breadcrumb"
      separator={<NavigateNextIcon fontSize="small" />}
    >
      {state.mainContent.navList.length
        ? state.mainContent.navList.map((nav: INavigation, idx: number) =>
            idx < state.mainContent.navList.length - 1 &&
            state.mainContent.navList.length > 1 ? (
              // &&
              // idx >= state.mainContent.navList.length - 2 &&
              // state.mainContent.fieldList.find(
              //   (btn: IField) => btn.name === "BACK"
              // )
              <Link
                color="inherit"
                href="/"
                onClick={(event) => handleClick(event)} //TODO
                key={nav.id}
                id={nav.id}
              >
                {nav.id}
              </Link>
            ) : (
              <Typography color="textPrimary" key={nav.id} id={nav.id}>
                {nav.id}
              </Typography>
            )
          )
        : ""}
    </Breadcrumbs>
  );
};
